import { createFileRoute } from "@tanstack/react-router";
import { feedInfiniteQuery, type FeedTab, trendingQuery } from "@/api/queries/feed";
import { suggestedCreatorsQuery } from "@/api/queries/creators";
import { meQuery } from "@/api/queries/me";
import { FeedPage } from "@/pages/feed/FeedPage";
import { FeedPageSkeleton } from "@/pages/feed/FeedPageSkeleton";

interface FeedSearch {
  tab?: FeedTab;
}

function parseTab(value: unknown): FeedTab {
  return value === "following" || value === "trending" ? value : "for-you";
}

export const Route = createFileRoute("/_app/feed")({
  validateSearch: (search): FeedSearch => ({ tab: parseTab(search.tab) }),
  loaderDeps: ({ search }) => ({ tab: parseTab(search.tab) }),
  loader: ({ context, deps }) => {
    const tab = deps.tab;
    void context.queryClient.prefetchInfiniteQuery(feedInfiniteQuery(tab));
    void context.queryClient.ensureQueryData(meQuery());
    void context.queryClient.prefetchQuery(trendingQuery());
    void context.queryClient.prefetchQuery(suggestedCreatorsQuery());
  },
  pendingComponent: FeedPageSkeleton,
  component: Feed,
});

function Feed() {
  const { tab } = Route.useSearch();
  return <FeedPage tab={tab ?? "for-you"} />;
}
